// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2su21","tab":"ProcedureTabs_tab__NPL2i"};